/* tslint:disable:max-line-length */
import * as React from 'react'
import Container from '../../common/Container/Container'
import RenewalsTable from './components/RenewalsTable'
import RenewalsTableHeader from './components/RenewalsTableHeader'
import Widget from '../../common/Widget/Widget'
import './styles/Renewals.css'
import { Button } from '../../common/Button/Button'
import PopUp from '../../common/PopUp/PopUp'
import { get } from 'lodash'

import {
    fecthLapseRenewal,
} from '../../../actions'
import Loading from '../../common/Loading/Loading'
import RenewalHeaderContainer from '../../common/HeaderContainer/RenewalHeaderContainer'

export default class Renewals extends React.Component<any, any> {
    initialFilters = {
        perPage: 20,
        sortedBy: 'clientName',
        sortedType: 'asc',
    }

    constructor(props: any) {
        super(props)
        this.state = {
            renewPolicyPopUp: {
                show: false,
                renewId: '',
            },
            futureExpiringPopUp: {
                show: false,
                renewId: '',
            },
            futureLapsePopUp: {
                show: false,
                renewId: '',
            },
            filters: { ...this.initialFilters },
            typeSelected: this.getTypeFromProps(props),
            sections: {
                'future': { 'title': 'Future renewals', 'type': 'futureRenewals', show: false },
                'invites': { 'title': 'Invited renewals', 'type': 'invitedRenewals', show: true },
                'referrals': { 'title': 'In referral', 'type': 'inReferral', show: true },
            },
            viewInvitePopUp: {
                success: false,
                error: false,
            },
            renewPolicyReasonPopUp: false,
            reasonRenewId: '',
            renewalReason: '',
            page: 1,
            inviteLoading: false,
            renewalReferred: {
                msg: '',
                show: false,
            },
        }
    }

    componentDidMount() {
        this.fetchRenewalsList()
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const prevType = this.getTypeFromProps(prevProps)
        const currentType = this.getTypeFromProps(this.props)

        if (prevType !== currentType) {
            this.setState({
                filters: { ...this.initialFilters },
                typeSelected: currentType,
                page: 1,
            })
        }

        if (
            prevState.filters !== this.state.filters ||
            prevState.typeSelected !== this.state.typeSelected
        ) {
            this.fetchRenewalsList()
        }

        if (prevState.page !== this.state.page && prevState.typeSelected === this.state.typeSelected) {
            this.fetchRenewalsList(true)
        }
    }

    getTypeFromProps(props: any) {
        return get(props, 'match.params.type', 'invites')
    }

    fetchRenewalsList = (loadMore = false) => {
        const { perPage, sortedBy, sortedType } = this.state.filters
        const type = this.state.typeSelected
        const page = this.state.page
        if (loadMore) {
            this.props.loadMoreRenewalsList(page, perPage, sortedBy, sortedType, type)
        } else {
            this.props.fecthRenewalsList(page, perPage, sortedBy, sortedType, type)

        }
    }

    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    showRenewPolicyPopUp = (state: any, newId: any) => {
        this.setState({
            renewPolicyPopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    showFutureExpiringPopUp = (state: any, newId: any) => {
        this.setState({
            futureExpiringPopUp: {
                show: state,
                renewId: newId,
            },
            reasonRenewId: newId,
        })
    }

    showFutureLapsePopUp = (state: any, newId: any) => {
        this.setState({
            futureLapsePopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    inviteQuoteVariation = (v: any) => {
        this.props.inviteQuoteVariation(v)
            .then((response) => {
                const isReferral = get(response, 'is_referral', 0) === 1
                const errorMsg = get(response, 'error', '')

                if (response.success !== false) {
                    this.setState({ viewInvitePopUp: { success: true }, inviteLoading: false })
                    this.policyActionAfter(v)
                }

                if (isReferral) {
                    this.setState({ renewalReferred: { msg: errorMsg }, renewPolicyReasonPopUp: true })
                }
            })
            .catch((response) => {
                const isReferral = get(response, 'is_referral', 0) === 1
                const errorMsg = get(response, 'error', '')

                this.setState({ inviteLoading: false })

                if (isReferral) {
                    this.setState({ renewalReferred: { msg: errorMsg }, renewPolicyReasonPopUp: true })
                    this.policyActionAfter(v)
                } else {
                    this.setState({ viewInvitePopUp: { error: errorMsg } })
                }
            })
    }

    renewReferReason = () => {
        this.setState({ renewPolicyReasonPopUp: false, inviteLoading: true })
        this.props.renewalReferralReasons(
            this.state.reasonRenewId,
            { reason: this.state.renewalReason }
        ).then((res) => {
            this.referralReasonAfter()
        }).catch((res) => {
            this.referralReasonAfter()
        })
    }

    referralReasonAfter = () => {
        this.setState({
            inviteLoading: false, reasonRenewId: '', renewalReason: '',
            renewalReferred: { ...this.state.renewalReferred, show: true },
        })
    }

    handleReasonChange = (r: any) => {
        this.setState({
            renewalReason: r,
        })
    }

    changeSelectedType = (newType: string) => {
        this.props.history.push(`/renewals/${newType}`)
    }

    policyActionAfter = (Id: any) => {
        this.props.policyActionAfter(Id)
    }

    render() {
        const { done, response, loading = false, loadMore = false } = this.props.renewals
        const { sections, typeSelected } = this.state
        const renewalsList = get(response, 'list', [])
        const total = get(response, 'total', 0)

        return (
            <div className="renewals">
                {(this.state.viewInvitePopUp.success) ?
                    <PopUp
                        title="Quote invited"
                        action={() => {
                            this.setState({ viewInvitePopUp: { success: false } })
                        }}
                        buttonText="OK"

                    >
                        Thank you for issuing the quote; this will be emailed to you.
                    </PopUp>
                    : null}
                {(this.state.inviteLoading) ? (<PopUp
                    title="Quote invited"
                    action={() => { '' }}
                    buttonText="Loading"

                >
                    ...loading
                </PopUp>) : null}
                {
                    (this.state.viewInvitePopUp.error) ?
                        < PopUp
                            title="Something went wrong"
                            buttonText="Close"
                            action={() => {
                                this.setState({ viewInvitePopUp: { error: false } })
                            }}
                        >
                            {this.state.viewInvitePopUp.error}
                        </ PopUp>
                        :
                        null
                }
                {
                    (this.state.renewalReferred.show) && (this.state.renewalReferred.msg) ?
                        < PopUp
                            title="Renewal Referred"
                            buttonText="Close"
                            action={() => {
                                this.setState({ renewalReferred: { show: false, msg: '' } })
                            }}
                        >
                            {this.state.renewalReferred.msg}
                        </ PopUp>
                        :
                        null
                }
                {(this.state.renewPolicyPopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Renew Policy'}
                            action={() => this.props.history
                                .push(`/renewals/bind/${this.state.renewPolicyPopUp.renewId}`)}
                            buttonText={'Bind Renewal'}
                            numberButtons={3}
                            secondaryAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.renewPolicyPopUp.renewId}`)
                            }}
                            secondaryButtonText={'Edit Renewal'}
                            thirdAction={() => { this.setState({ renewPolicyPopUp: { show: false } }) }}
                            thirdButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            {/* <div className="download_pdf_policy">
                                Download pdf policy form
                            </div> */}
                        </PopUp>
                    </div>
                    : null}
                {(this.state.futureExpiringPopUp.show) ?
                    <div className="">
                        <PopUp
                            customClassName="fifth_renewal_popup"
                            title={'Renew Policy'}
                            numberButtons={5}

                            action={() => {
                                this.setState({ futureExpiringPopUp: { show: false } })
                                this.showFutureLapsePopUp(true, this.state.futureExpiringPopUp.renewId)
                            }}
                            buttonText={'Lapse'}

                            secondaryAction={() => this.props.history
                                .push(`/renewals/bind/${this.state.futureExpiringPopUp.renewId}`)}
                            secondaryButtonText={'Bind Renewal\n as expiring'}

                            thirdAction={() => {
                                this.setState({ futureExpiringPopUp: { show: false }, inviteLoading: true })
                                this.inviteQuoteVariation(this.state.futureExpiringPopUp.renewId)
                            }}
                            thirdButtonText={'Invite Renewal\n as expiring'}

                            fourthAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.futureExpiringPopUp.renewId}`)
                            }}
                            fourthButtonText={'Edit Renewal'}

                            fifthAction={() => { this.setState({ futureExpiringPopUp: { show: false } }) }}
                            fifthButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            <div className="download_pdf_policy">
                                Download expiring policy
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.state.futureLapsePopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Are you sure?'}
                            action={() => {
                                fecthLapseRenewal(this.state.futureLapsePopUp.renewId)
                                this.setState({ futureLapsePopUp: { show: false } })
                            }}
                            buttonText={'Continue'}
                            numberButtons={2}
                            secondaryAction={() => { this.setState({ futureLapsePopUp: { show: false } }) }}
                            secondaryButtonText={'Cancel'}
                        >
                            Do you really want to lapse the renewal?
                        </PopUp>
                    </div>
                    : null}
                {(this.state.renewPolicyReasonPopUp) ?
                    <PopUp
                        title="Renewal Policy Reason"
                        buttonText="Accept"
                        action={() => {
                            this.renewReferReason()
                        }}
                        numberButtons={2}
                        secondaryAction={() => {
                            this.setState(
                                {
                                    renewPolicyReasonPopUp: false, reasonRenewId: '', renewalReason: '',
                                    renewalReferred: { ...this.state.renewalReferred, show: true },
                                }
                            )
                        }}
                        secondaryButtonText={'Cancel'}
                    >
                        <div className="quotePreview__box softRef">
                            Due to the below you will need to provide more information.

                            <div className="softRef__list">
                                {/* {props.referrals.map((ref, i) => (
                                    <div key={i} className="softRef__item">
                                        <span>{ref.title}:</span>
                                        {ref.description}
                                    </div>
                                ))} */}
                            </div>

                            <textarea
                                placeholder="Explain in a few words your reasons"
                                onChange={(event) => { this.handleReasonChange(event.target.value) }}
                            />
                        </div>
                    </PopUp>
                    : null}
                <RenewalHeaderContainer
                    className="renewals__header"
                    fullwidth={true}
                    pretitle={'Renewals'}
                    sections={sections}
                    selected={typeSelected}
                    triggerAction={this.changeSelectedType}
                />

                <RenewalsTableHeader
                    state={this.state.filters}
                    dataType={typeSelected}
                    filterTrigger={this.filterTrigger}
                />

                <div className="renewals-widget__body">
                    {loading && (<Loading />)}
                    {!loading && done && (
                        <div>
                            <Widget
                                shadow={true}
                                className={`renewals-widget-policies ${renewalsList.length === 0 ? 'renewals-widget-policies__void' : ''}`}
                            >
                                <div className="renewals-widget-quotes__title">
                                    <h3>{sections[typeSelected].title}</h3>
                                    <p>
                                        {`${total} ${(total !== 1) ?
                                            'policies' :
                                            'policy'} up for renewal in the next 45 days`}
                                    </p>
                                </div>
                                <div className="your-policies__content">
                                    <Container key={typeSelected} className="clients clients__table table__content">
                                        {typeSelected === 'future' && (
                                            <RenewalsTable
                                                renewalsList={renewalsList}
                                                dataType="futureRenewals"
                                                // showRenewPolicyPopUp={this.showRenewPolicyPopUp}
                                                showRenewPolicyPopUp={this.showFutureExpiringPopUp}
                                                showLapseRenewPopUp={this.showFutureLapsePopUp}
                                            />
                                        )}
                                        {typeSelected === 'invites' && (
                                            <RenewalsTable
                                                renewalsList={renewalsList}
                                                dataType="invitedRenewals"
                                                referralType="invitedRenewals"
                                                renewAsIs={this.props.renewAsIs.response}
                                                fecthRenewAsIs={(policyId) => this.props.fecthRenewAsIs(policyId)}
                                                fecthRenewPolicy={(policyId) => this.props.fecthRenewPolicy(policyId)}
                                                showRenewPolicyPopUp={this.showRenewPolicyPopUp}
                                                history={this.props.history}
                                            />
                                        )}
                                        {typeSelected === 'referrals' && (
                                            <RenewalsTable
                                                renewalsList={renewalsList}
                                                dataType="inReferral"
                                                referralType="inReferral"
                                            />
                                        )}
                                    </Container>
                                    {renewalsList.length !== total && (
                                        <div className="clients__footer">
                                            <div className="clients__footer--brick quote_load_more">
                                                <Button
                                                    disabled={renewalsList.length === total}
                                                    type="submit"
                                                    onClick={() => {
                                                        this.setState(prevState => ({
                                                            page: prevState.page + 1,
                                                        }))
                                                    }}
                                                >
                                                    {loadMore ? <Loading /> : 'Load more'}
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Widget>

                            <div className={`no-results-widget ${renewalsList.length === 0 ? 'active' : 'blocked'}`}>
                                There are no results for {typeSelected} renewals
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/Renewals.tsx